import React from 'react'
import NavbarProjects from './NavbarProjects'
import BannerBackground from "../Assets/home-banner-background.png";
import CardItem from './CardItem'


function Projects001() {

  const workInfoData = [
    {
      image: "../images/p001001.jpg",
      title: "Reparaciones",
      text: "Nuestro equipo tecnico tiene capacidad para reparar una variedad the sistemas complejos",
    },
    {
      image: "../images/p001002.jpg",
      title: "Mantenimiento",
      text: "Brindamos servicio de mantenimiento para equipo industrial o maquinaria de construction",
    },
    {
      image: "../images/p001004.jpg",
      title: "Venta de partes",
      text: "Comercializamos partes para diferentes sistemas hidraulicos como sellos, bombas y todo tipo de partes industriales",
    },
    {
      image: "../images/p001005.jpg",
      title: "Customizaciones",
      text: "Fabricamos partes y hacemos customizaciones con la mas alta calidad de mano de obra y siempre siguiendo requerimientos",
    },
    {
      image: "../images/p001IMG_5442_2.jpg",
      title: "Customizaciones",
      text: "Fabricamos partes y hacemos customizaciones con la mas alta calidad de mano de obra y siempre siguiendo requerimientos",
    }
    
  ];


  return (
    <div className="home-container">
      <NavbarProjects />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
      </div>
      <div className="home-text-section">
        <h1 className="primary-heading">
          Especialistas en Sistemas Hidraulicos
        </h1>
      </div>


      <div className='cards'>
        <div className="work-section-bottom">
          {workInfoData.map((data) => (
            <div className="work-section-info-single" key={data.title}>
              <div className="none">
                <img src={data.image} alt="" />
              </div>
              <h2>{data.title}</h2>
              <p>{data.text}</p>
            </div>
          ))}
        </div>

      </div>


    </div>

  )
}

export default Projects001